<div class="col-sm-12 mct-flex mct-col mb-12">
  <label class="control-label">{{ 'common.personal-information.address-type' | translate | titlecase }}</label>
  <select [(ngModel)]="profileAddressSettings.AddressTypeId" (change)="onAddressTypeChange()">
    <option *ngFor="let addressType of addressTypes" [ngValue]="addressType.AddressTypeID">
      {{ addressType.AddressType }}
    </option>
  </select>
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.Address1.Visible" />{{
      'common.personal-information.address1' | translate | titlecase
    }}</label
  >

  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.Address1.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.Address2.Visible" />{{
      'common.personal-information.address2' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.Address2.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.City.Visible" />{{
      'common.personal-information.city' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.City.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.State.Visible" />{{
      'common.personal-information.state' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.State.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.Zip.Visible" />{{
      'common.personal-information.zip' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.Zip.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.ZipExt.Visible" />{{
      'common.personal-information.zipext' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.ZipExt.LabelText"
  />
</div>
<div style="clear: both"></div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.County.Visible" />{{
      'common.personal-information.county' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.County.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label"
    ><input type="checkbox" [(ngModel)]="profileAddressSettings.Country.Visible" />{{
      'common.personal-information.country' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="profileAddressSettings.Country.LabelText"
  />
</div>
<div style="clear: both"></div>
